import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

const OPEN = ["/subscribe", "/payment"];

export const AccessGate = ({ children }) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/billing/me").then((r) => setActive(r.data.active)).catch(() => setActive(true)); }, [pathname]);
  if (active === null) {
    return <div className="min-h-screen grid place-items-center" data-testid="access-gate-loading"><Loader2 className="h-6 w-6 animate-spin text-emerald-400" /></div>;
  }
  if (active === false && !OPEN.some((p) => pathname.startsWith(p))) return <Navigate to="/subscribe" replace />;
  return children;
};
